import React, { useEffect, useRef } from 'react';

const Toast = ({ message, type = 'error', onClose, duration = 5000 }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (duration > 0 && message) {
      const timer = setTimeout(() => {
        onCloseRef.current();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, message]);

  if (!message) return null;

  return (
    <div className={`auth-error-toast ${type === 'success' ? 'auth-success-toast' : ''}`}>
      <div className="error-content">
        <i className={`fas fa-${type === 'error' ? 'exclamation-circle' : 'check-circle'}`}></i>
        <span>{message}</span>
      </div>
      <button className="error-close" onClick={onClose} aria-label="Close">
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default Toast;
